import axiosClient from "api/axios-client";

export const GetPendingApproval = async ()=>{
    const response = await axiosClient.get(`/ifincredit/dashboard/taskManager/`)
    //console.log(response)
    return response
}